import NaruckoLogoBlack from '@assets/narucko-logo-black.svg';
import BaseContainer from '@components/common/atoms/container/BaseContainer';
import OrderCartIcon from '@components/order/components/order-cart/mobile/OrderCartIcon';
import { useRootStore } from '@hooks/useRootStore';
import { useScrollTrigger } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NavigationMenu from './NavigationMenu';
import { grey } from '@mui/material/colors';
import PersonIcon from '@mui/icons-material/Person';
import HeaderIcon from './HeaderIcon';

const pages = ['Profil', 'Moje narudžbe'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const ResponsiveAppBar = observer(() => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const { authorizationStore, authenticationStore } = useRootStore();
    const { isUserLoggedIn, user } = authorizationStore;
    const { setIsLoginDrawerOpen } = authenticationStore;

    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        if (isUserLoggedIn) {
            setAnchorElUser(event.currentTarget);
        }
        else {
            setIsLoginDrawerOpen(true);
        }
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleOnNavigationMenuClick = (route: string) => {
        navigate(route)
        handleCloseUserMenu()
    }

    return (
        <ElevationScroll pathName={pathname}>
            <AppBar position="sticky" elevation={1} sx={{ bgcolor: "background.default" }}>
                <BaseContainer useLeftAndRightPadding>
                    <Toolbar disableGutters>
                        <Box sx={{ flexGrow: 1 }}>
                            <HeaderIcon />
                        </Box>

                        <Box sx={{ display: { xs: 'none', md: 'none', gap: 12 } }}>
                            {pages.map((page) => (
                                <Button
                                    key={page}
                                    color='inherit'
                                    variant='outlined'
                                    onClick={handleCloseNavMenu}
                                    sx={{ my: 2, display: 'block' }}
                                >
                                    <Typography>
                                        {page}
                                    </Typography>
                                </Button>
                            ))}
                        </Box>

                        <Box sx={{ flexGrow: 0 }}>
                            <OrderCartIcon />

                            <Tooltip title="Postavke">
                                <IconButton
                                    onClick={handleOpenUserMenu}
                                    sx={{
                                        p: 0,
                                    }}>
                                    <Avatar
                                        sx={{
                                            bgcolor: grey[200],
                                            color: (theme) => theme.palette.secondary.main
                                        }}
                                    >
                                        {user?.firstName.charAt(0)}
                                    </Avatar>
                                </IconButton>
                            </Tooltip>

                            {user !== null && (
                                <Menu
                                    sx={{ mt: '45px' }}
                                    id="menu-appbar"
                                    anchorEl={anchorElUser}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorElUser)}
                                    onClose={handleCloseUserMenu}
                                >
                                    <NavigationMenu onClick={handleOnNavigationMenuClick} user={user!} />
                                </Menu>
                            )}
                        </Box>
                    </Toolbar>
                </BaseContainer>
            </AppBar>
        </ElevationScroll>
    );
})

export default ResponsiveAppBar;

interface Props {
    children: React.ReactElement;
    pathName: string;
}

function ElevationScroll(props: Props) {
    const { children } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
    });

    let style = {};

    // if (props.pathName === "/") {
    // }
    // else if (props.pathName.includes("/")|| props.pathName.includes("/offer")) {
    //     style = {
    //         backgroundColor: trigger ? "#fff" : "transparent",
    //     }
    // }

    style = {
        backgroundColor: trigger ? "#fff" : "transparent",
    }

    return React.cloneElement(children, {
        elevation: trigger ? 1 : 0,
        style: style
    });
}